var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71154 19.125H4.875L4.875 15.281L12.8221 7.31852M8.71154 19.125L19.125 19.125M8.71154 19.125L16.6587 11.1625M12.8221 7.31852L14.4663 5.67111C15.5258 4.60962 17.2435 4.60962 18.3029 5.67111C19.3623 6.73259 19.3623 8.4536 18.3029 9.51508L16.6587 11.1625M12.8221 7.31852L16.6587 11.1625",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1e9133ebf386832faa76c4c51c32daef.svg";
export { ForwardRef as ReactComponent };